import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const RELATIONSHIP_PATH = "/master/v1/relationship";

export const getRelationshipApi = async (params) =>
  await getRequest(RELATIONSHIP_PATH, params);

export const getRelationshipByIdApi = async (id) =>
  await getRequest(`${RELATIONSHIP_PATH}/${id}`);

export const addRelationshipApi = async (body) =>
  await postRequest(RELATIONSHIP_PATH, body);

export const updateRelationshipApi = async (body) =>
  await putRequest(`${RELATIONSHIP_PATH}/${body?._id}`, body);

export const deleteRelationshipByIdApi = async (id) =>
  await deleteRequest(`${RELATIONSHIP_PATH}/${id}`);
